<template>
  <v-dialog
    v-model="open"
    width="700"
    scrollable
  >
    <v-card>
      <v-card-title
        class="headline primary darken-1"
        primary-title
      >
        Comments
      </v-card-title>

      <v-card-subtitle class="py-0 mt-5">
        <v-timeline dense>
          <v-timeline-item large fill-dot>
            <template v-slot:icon>
              <span class="display-1 white--text">{{getInitials}}</span>
            </template>
            <v-textarea
              v-model="newComment"
              hide-details
              rows="2"
              flat
              label="Leave a comment..."
            >
              <template v-slot:append-outer>
                <v-btn
                  :disabled="newComment.length === 0"
                  class="mx-0"
                  @click="submit"
                >
                  Comment
                </v-btn>
              </template>
            </v-textarea>
          </v-timeline-item>
        </v-timeline>
      </v-card-subtitle>
      <v-card-text class="" v-if="!loading">
        <!--timeline-->
        <v-timeline dense v-if="comments.length > 0">
          <v-timeline-item
            small
            fill-dot
            v-for="(comment, i) in comments"
            :key="i"
          >
            <v-row>
              <v-col cols="3">
                <h4 class="subtitle-2">{{comment.date.toLocaleString()}}</h4>
              </v-col>
              <v-col>
                <h4 class="subtitle-1">{{comment.user.name}}</h4>
                <p>{{comment.text}}</p>
              </v-col>
            </v-row>
          </v-timeline-item>


          <!--textarea-->
        </v-timeline>
        <v-alert class="text-center" v-else>
          There are no comments yet
        </v-alert>
      </v-card-text>
      <profile-comments-timeline-boiler class="mx-9" v-else></profile-comments-timeline-boiler>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <!--<v-btn color="primary" text :disabled="newComment.length === 0" @click="submit()">
          Save
        </v-btn>-->
        <v-btn color="default" text @click="cancel()">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import api from '@/api';
  import Vue from "vue";
  import ProfileCommentsTimelineBoiler from "../../Boilerpalettes/profileCommentsTimelineBoiler";

  export default {
    name: "showComments",
    components: {ProfileCommentsTimelineBoiler},
    props: ['profileId'],
    data: () => ({
      open: false,
      comments: [],
      newComment: '',
      loading: false
    }),
    computed: {
      getInitials() {
        return this.$store.getters.getUserFromToken.name.split(' ').map(e => e[0].toUpperCase()).join('');
      }
    },
    methods: {
      openModal() {
        this.open = true;
        this.loading = true;
        this.getProfileComments();
      },
      getProfileComments() {
        api.members.getComments({_id: this.profileId})
        .then(response => {
          this.loading = false;
          this.comments = response.data.data.comments.map(comment => ({...comment, date: new Date(comment.date), }));
        })
      },
      cancel() {
        this.open = false;
        //this.$ga.event('Members', 'cancel', 'export');
      },
      submit() {
        const {_id, name} = this.$store.getters.getUserFromToken;
        const payload = {
          _id: this.profileId,
          date: new Date(),
          text: this.newComment,
          user: {_id, name}
        }
        api.members.addComment(payload)
        .then(response => {
          Vue.notify({
            group: 'actions',
            type: 'success',
            text: 'Comment added'
          });
          this.comments = [payload, ...this.comments];
          this.$emit('comment-added', {commentsCount: this.comments.length} )
        })
        .catch(error => {
          console.log(error)
          Vue.notify({
            group: 'actions',
            type: 'error',
            text: 'Comment could not be added'
          });
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Profiles/showComments.vue